import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { reduxForm, initialize, destroy, propTypes } from 'redux-form'
import { CheckboxField } from 'components/forms'
import { FormattedHTMLMessage } from 'react-intl'
import { Button, SvgSpriteSheet } from 'components/util'

import styles from 'components/deletion/_deletion.css'
import SecondaryForm from './SecondaryVerification'

export const FORM_NAME = 'mvpConfirm'

const validate = (values) => {
  const errors = {}
  if (!values.mvpconfirm) { errors.mvpconfirm = 'required' }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class MvpConfirmation extends Component {
  static propTypes = {
    ...propTypes,
    initialize: PropTypes.func,
    deactivate: PropTypes.func,
    email: PropTypes.string,
    user: PropTypes.object,
  }

  state = {
    nextPage: false,
  }

  handleNext = () => {
    this.setState({
      nextPage: true,
    })
  }

  handleContinue = (evt) => {
    if (this.props.invalid) {
      evt.preventDefault()
    }
  }

  render () {
    const { user, invalid, pristine, deactivate } = this.props

    return (
      <div className={styles.mvpConfirmContainer}>
        {this.state.nextPage ?
          <div className={styles.secondaryFormContainer}>
            <SecondaryForm
              onSubmit={deactivate}
              user={user}
            />
          </div>
        :
          <form method='post' onSubmit={this.handleNext} className={styles.deleteVerifyForm}>
            <h3 className={styles.deleteTitle}>
              <FormattedHTMLMessage
                id='auth.password.verfiy.mvpTitle'
                defaultMessage={`
                  Your MVP Subscription
                `}
              />
            </h3>
            <p className={styles.mvpText}>
              <FormattedHTMLMessage
                id='auth.password.verfiy.mvpText'
                defaultMessage={`
                  You have an active MVP subscription. Please be sure to cancel your subscription
                  before deleting your account or you will continue to be charged. For more information
                  on cancelling your subscription, see
                  <a href="https://support.mapmyfitness.com/hc/en-us/articles/206157776">How To Cancel MVP Membership</a>.
                `}
              />
            </p>

            <CheckboxField
              bold
              name='mvpconfirm'
              value='mvpconfirm'
              className={styles.mvpconfirm}
              labelComponent={<FormattedHTMLMessage
                id='delete.mvp.confirm'
                defaultMessage={`
                  I've already cancelled my MVP subscription.
                `}
              />}
            />

            <Button
              el='button'
              type='success'
              onClick={this.handleContinue}
              disabled={invalid || pristine}
              className={styles.button}
            >
              <FormattedHTMLMessage
                id='delete.mvp.btn.continue'
                defaultMessage={`
                  Continue
                `}
              />
            </Button>
            <SvgSpriteSheet />
          </form>
        }
      </div>
    )
  }

}

export const Form = reduxForm(formOptions)(MvpConfirmation)
export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)



// WEBPACK FOOTER //
// ./src/components/deletion/MvpConfirmation.jsx